import * as React from 'react';
import { useIntl } from 'umi';
import { Icon, BetaTag } from '@/components';
import Style from './index.less';

export interface p {}

const YunxinBottom: React.FC<p> = () => {
  const { formatMessage } = useIntl();
  return <div className={Style['yunxin-bottom']}>{formatMessage({ id: 'POWERED_BY' })}</div>;
};

export default YunxinBottom;
